<template>
  <div :class="className" class="title-widget">
    <component :is="component" class="text-decoration-none" v-bind="attrs">
      <slot />
      <v-icon v-if="link" class="mb-2" small> fas fa-external-link-alt</v-icon>
    </component>
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: "center",
      validator: (val) => ["left", "center", "right"].includes(val),
    },
    small: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
    },
  },
  computed: {
    className() {
      const alignClass = {
        left: "text-left align-start",
        center: "text-center align-center",
        right: "text-right align-end",
      };

      const className = [
        "title-widget d-flex flex-column justify-center font-weight-bold",
        alignClass[this.align],
        !this.dark ? "title-widget--light" : "title-widget--dark",
        !this.small && "text-h5 text-md-h4",
        this.link && "title-widget--link",
      ];

      return className;
    },
    attrs() {
      const attrs = {};

      if (this.link) {
        attrs.to = this.link;
      }

      return attrs;
    },
    component() {
      return this.link ? "router-link" : "span";
    },
  },
};
</script>

<style lang="scss">
.title-widget--light {
  --text: var(--v-primary-base);
  --decoration: var(--v-secondary-base);
  --hover-text: var(--v-primary-lighten1);
}
.title-widget--dark {
  --text: #ffffff;
  --decoration: var(--v-primary-base);
  --hover-text: #ccc;
}

.title-widget {
  text-decoration: none;

  &::after {
    content: "";
    width: 100%;
    max-width: 320px;
    height: 5px;
    display: block;
    background-color: var(--decoration);
    margin-top: 8px;
  }

  > * {
    color: var(--text) !important;
  }
}

.title-widget--link a {
  transition: 0.3s;

  i {
    opacity: 0;
    color: inherit !important;
  }

  &:hover {
    color: var(--hover-text) !important;

    i {
      opacity: 1;
    }
  }
}
</style>
